export function currency(value: number, cur: string) {
  return `${cur} ${value.toFixed(2)}`;
}
